/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reset_Your_Authentication_CredInputs */

const en_reset_your_authentication_cred = /** @type {(inputs: Reset_Your_Authentication_CredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset your authentication credentials.`)
};

const es_reset_your_authentication_cred = /** @type {(inputs: Reset_Your_Authentication_CredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablece tus credenciales de autenticación.`)
};

const fr_reset_your_authentication_cred = /** @type {(inputs: Reset_Your_Authentication_CredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réinitialisez vos identifiants d'authentification.`)
};

const de_reset_your_authentication_cred = /** @type {(inputs: Reset_Your_Authentication_CredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setze deine Authentifizierungsdaten zurück.`)
};

const ja_reset_your_authentication_cred = /** @type {(inputs: Reset_Your_Authentication_CredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`認証資格情報をリセットします。`)
};

const zh_reset_your_authentication_cred = /** @type {(inputs: Reset_Your_Authentication_CredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重置您的身份验证凭据。`)
};

const ar_reset_your_authentication_cred = /** @type {(inputs: Reset_Your_Authentication_CredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أعد تعيين بيانات الاعتماد الخاصة بك.`)
};

const id_reset_your_authentication_cred = /** @type {(inputs: Reset_Your_Authentication_CredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atur ulang kredensial autentikasi Anda.`)
};

const it_reset_your_authentication_cred = /** @type {(inputs: Reset_Your_Authentication_CredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reimposta le tue credenziali di autenticazione.`)
};

const ru_reset_your_authentication_cred = /** @type {(inputs: Reset_Your_Authentication_CredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сброс ваших учетных данных аутентификации.`)
};

const pt_reset_your_authentication_cred = /** @type {(inputs: Reset_Your_Authentication_CredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redefina suas credenciais de autenticação.`)
};

const ko_reset_your_authentication_cred = /** @type {(inputs: Reset_Your_Authentication_CredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인증 자격 증명을 재설정하세요.`)
};

/**
* | output |
* | --- |
* | "Reset your authentication credentials." |
*
* @param {Reset_Your_Authentication_CredInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const reset_your_authentication_cred = /** @type {((inputs?: Reset_Your_Authentication_CredInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_Your_Authentication_CredInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reset_your_authentication_cred(inputs)
	if (locale === "es") return es_reset_your_authentication_cred(inputs)
	if (locale === "fr") return fr_reset_your_authentication_cred(inputs)
	if (locale === "de") return de_reset_your_authentication_cred(inputs)
	if (locale === "ja") return ja_reset_your_authentication_cred(inputs)
	if (locale === "zh") return zh_reset_your_authentication_cred(inputs)
	if (locale === "ar") return ar_reset_your_authentication_cred(inputs)
	if (locale === "id") return id_reset_your_authentication_cred(inputs)
	if (locale === "it") return it_reset_your_authentication_cred(inputs)
	if (locale === "ru") return ru_reset_your_authentication_cred(inputs)
	if (locale === "pt") return pt_reset_your_authentication_cred(inputs)
	return ko_reset_your_authentication_cred(inputs)
});